export var themed = function themed(key) {
  return function (props) {
    return props.theme[key];
  };
};
export var customSystem = function customSystem(themeField, propName) {
  return function (props) {
    return props.theme[themeField][props[propName]];
  };
};